import { IBaseApiResponse } from '@interfaces/generic.interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IGenpar {
  descr: string;
  value: string;
  descrLong: string;
  parameter: string;
  subModule: string;
}

export interface IGenparAPI extends IBaseApiResponse {
  data: { parameter: IGenpar }[];
}

const initialState: IGenpar[] = [];

export const GenparSlice = createSlice({
  name: 'genpar',
  initialState,
  reducers: {
    setGenpar: (_state, action: PayloadAction<IGenpar[]>) => {
      return action.payload;
    },
    clearGenpar: () => {
      return initialState;
    },
  },
});

export default GenparSlice.reducer;

export const { setGenpar, clearGenpar } = GenparSlice.actions;
